export default __webpack_public_path__ + "static/media/camp-2.4ad737e9.jpg";